import { useMemo } from 'react';
import { Button, Empty, Icon } from 'ui';
import type { ChatroomSidebarContentFilter } from '../../hooks';

type P = {
  filter: ChatroomSidebarContentFilter;
  onCreateChatClicked: () => void;
};

const ChatroomSidebarEmpty = ({ filter, onCreateChatClicked }: P) => {
  const description = useMemo(() => {
    if (filter.search) {
      return {
        subtitle: 'Try refining your search terms or start a new conversation',
        title: 'No results found',
      };
    }

    switch (filter.type) {
      case 'groups':
        return {
          subtitle: 'Your group messages will appear here',
          title: 'No group messages',
        };
      case undefined:
        return {
          subtitle: 'Create a message to start a new conversation',
          title: 'No messages yet',
        };
      case 'unread':
        return {
          subtitle: 'Your unread messages will appear here',
          title: 'No unread messages',
        };
    }
  }, [filter]);

  return (
    <Empty description={description} fitCenter image={<Icon icon={filter.search ? 'search-2-line' : 'inbox-line'} />}>
      <Button onClick={onCreateChatClicked} type="link-primary">
        Create a message
      </Button>
    </Empty>
  );
};

export default ChatroomSidebarEmpty;
